import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { CreateReviewInterface } from '@/services/Dossier/review/interfaces';

export default class CreateFeedbackForm {
  public categoryId: number = 0;
  public typeId: number = 1;

  public title: string = '';
  public body: string = '';

  public forMonth: string = new Date().toISOString().substr(0, 7);

  public reviews: CreateReviewInterface[] = [
    {
      categoryId: 6,
      body: '',
    },
  ];

  public rules: { [key: string]: FormValidationFunction[] } = {
    categoryId: [
      (v: number) => !!v || 'You have to select feedback category',
    ],
    typeId: [
      (v: number) => !!v || 'You have to select feedback type',
    ],
    title: [
      (v: string) => !!v || 'You have to add title',
    ],
    body: [
      (v: string) => {
        return !!v || 'You have to add at text';
      },
    ],
    forMonth: [
      (v: string) => {
        return !!v || 'You have to add Month for the feedback';
      },
    ],
  };
}
